import { useEffect } from "react";
import { SEO } from "@/components/SEO";
import { StatsStrip, BrandShowcase } from "@/components/presence/BrandShowcase";
import { DomesticNetwork, InternationalCorridor, ExportCapabilities, PresenceCTA } from "@/components/presence/NetworkSections";

export default function GlobalPresencePage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div data-testid="global-presence-page" className="pt-20 lg:pt-24">
      <SEO
        title="Our Presence | Krish Fashion, IOLY & KF Prints — Pan-India, Dubai & Saudi Arabia"
        description="Three brands, one legacy: Krish Fashion unstitched dress materials across India, IOLY readymade garments in Gujarat, Rajasthan, Punjab, Bangalore & Kerala, and KF Prints fabrics from Surat to Mumbai, Dubai and Saudi Arabia."
        keywords="Indian textile brands, Krish Fashion, IOLY garments, textile exporter Dubai, fabric supplier Saudi Arabia, pan India textile distribution, Surat fabric manufacturer"
        path="/global-presence"
      />

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="section-divider mb-8" />
          <h1 className="text-5xl md:text-7xl font-serif tracking-tight text-foreground mb-6">
            Three Brands.<br />One Legacy.
          </h1>
          <p className="text-base md:text-lg font-sans text-muted-foreground max-w-2xl leading-relaxed">
            From our manufacturing base in Surat to wardrobes across India — and to long-standing partners in the Gulf — our brands carry 75 years of textile craftsmanship into every market they serve.
          </p>
        </div>
      </section>

      <StatsStrip />
      <BrandShowcase />
      <DomesticNetwork />
      <InternationalCorridor />
      <ExportCapabilities />
      <PresenceCTA />
    </div>
  );
}
